<script lang="ts">
	import { UiScaleSetter, getThemeVariables } from '@repo/ui'
	import '@repo/ui/form.css'
	import '@repo/ui/theme.css'
	import { colorTheme } from '@store/theme'

	interface Props {
		children?: import('svelte').Snippet
	}

	let { children }: Props = $props()
</script>

<UiScaleSetter />

<div
	id="root"
	style={getThemeVariables($colorTheme)}
	class="font-body text-body contents text-base dark:bg-gray-900 dark:text-gray-100"
>
	{@render children?.()}
</div>
